import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { CModal, CModalBody, CModalFooter, CModalHeader, CModalTitle, CButton, CCloseButton } from '@coreui/react-pro';

import { TAB_SELECT_PURCHASE } from '../../../../../../constants';
import images from '../../../../../../assets/images/index';
import { SimpleMultiSelectGroup } from '../../../../../General/Forms';

import { setShow } from '../../../../../../actions/general';
import { setListEventOptionsAttached } from '../../actions';

const SelectAttachedEvent = ({ product, listProductCart, setListProductCart, option }) => {
     const dispatch = useDispatch();
     const listEventOptionsAttached = useSelector((state) => state.subscriber.attachedEvents.listEventsOptionsAttached);

     const [listEventSelected, setListEventSelected] = useState(() => {
          if (listEventOptionsAttached?.some((item) => item.selected)) {
               return listEventOptionsAttached;
          } else {
               return [];
          }
     });

     const handleCancelButtonClick = () => {
          dispatch(setShow());

          let newListProductCart = [...listProductCart];
          const productCartIndex = listProductCart.findIndex((prod) => prod.id === product.id);
          newListProductCart[productCartIndex].selected = !newListProductCart[productCartIndex].selected;
          newListProductCart = listProductCart.filter((item) => item.id !== newListProductCart[productCartIndex].id);

          setListProductCart(newListProductCart);
          dispatch(setListEventOptionsAttached(listEventSelected));
     };

     const handleChangeSelect = (id, selected) => {
          setListEventSelected(selected);
     };

     const handleSaveChange = () => {
          let newListProductCart = [...listProductCart];
          const productCartIndex = listProductCart.findIndex((prod) => prod.id === product.id);

          if (listEventSelected.length > 0) {
               newListProductCart[productCartIndex].listEventsAttached = listEventSelected;
          } else {
               delete newListProductCart[productCartIndex].listEventsAttached;
               newListProductCart[productCartIndex].selected = !newListProductCart[productCartIndex].selected;
               newListProductCart = listProductCart.filter((item) => item.id !== newListProductCart[productCartIndex].id);
          }

          setListProductCart(newListProductCart);
          dispatch(setListEventOptionsAttached(listEventSelected));
          dispatch(setShow());
     };

     const reducedSeatEvent = (event) => {
          const newListEvents = [...listEventSelected];
          const eventIndex = newListEvents.findIndex((item) => item.value === event.value);

          if (eventIndex !== -1) {
               const newQuantity = event.quantity > 1 ? event.quantity - 1 : event.quantity;
               newListEvents[eventIndex].quantity = newQuantity;
          }
          setListEventSelected(newListEvents);
     };

     const increaseSeatEvent = (event) => {
          const newListEvents = [...listEventSelected];
          const eventIndex = newListEvents.findIndex((item) => item.value === event.value);

          if (eventIndex !== -1) {
               let newQuantity = event.quantity;
               if (event.remainingSeats > event.quantity) {
                    newQuantity = event.quantity + 1;
               }
               newListEvents[eventIndex].quantity = newQuantity;
          }
          setListEventSelected(newListEvents);
     };

     return (
          <CModal alignment="center" visible={true} className="attached-events-popup">
               <CModalHeader closeButton={false}>
                    <CModalTitle>Select the attached event</CModalTitle>
                    <CCloseButton onClick={handleCancelButtonClick} />
               </CModalHeader>
               <CModalBody>
                    <SimpleMultiSelectGroup id="events" name="events" options={listEventOptionsAttached} setFieldValue={handleChangeSelect} />
                    <div>
                         {listEventSelected.map((event) => {
                              return (
                                   <div className="attached-events-popup-item" key={event.value}>
                                        <div className="d-flex justify-content-start align-items-center">
                                             {option === TAB_SELECT_PURCHASE.TEAM_TRAINING && (
                                                  <div className="change-seat">
                                                       <div className="btn-change-seat d-flex align-items-center">
                                                            <span className="btn btn-change-seat-item" onClick={() => reducedSeatEvent(event)}>
                                                                 -
                                                            </span>
                                                            <span className="seat">
                                                                 <img src={images.IconColorMan} width={20} height={20} alt="Icon Color Man" />
                                                                 <span className="quantity">{event.quantity}</span>
                                                            </span>
                                                            <span className="btn btn-change-seat-item" onClick={() => increaseSeatEvent(event)}>
                                                                 +
                                                            </span>
                                                       </div>
                                                  </div>
                                             )}
                                             {event.text}
                                        </div>
                                   </div>
                              );
                         })}
                    </div>
               </CModalBody>
               <CModalFooter>
                    <div className="modal-footer-start">
                         <CButton color="primary" className="me-3" onClick={handleSaveChange}>
                              Save Change
                         </CButton>
                         <CButton color="secondary" onClick={handleCancelButtonClick}>
                              Remove All
                         </CButton>
                    </div>
               </CModalFooter>
          </CModal>
     );
};

export default SelectAttachedEvent;
